import { defineCustomElements, applyPolyfills } from '@watermarkinsights/ripple/dist/loader';
applyPolyfills().then(function () { return defineCustomElements(); });
export * from './components';
//# sourceMappingURL=index.js.map